import surveysStore from 'modules/report/stores/surveys'
import ImpressionsDrilldown from '../impression/Drilldown'

export default class SurveysDrilldown extends ImpressionsDrilldown {
  store = surveysStore
  report = 'surveys'

  metrics = {
    answered: { label: 'Answered', field: 'answer', value: 'answered' },
    notAnswered: { label: 'Not Answered', field: 'not-answered', value: true },
    total: { label: 'Impressions' },
  }
}
